import React from 'react';
import PropTypes from 'prop-types';

import { StyledWrapper, StyledForm, StyledH4, StyledP, StyledInput, StyledFormSwitcher, StyledHiddenLabel } from './AccountFormStyles';

var _ref2 = React.createElement(
  StyledH4,
  null,
  'Reset your password'
);

var _ref3 = React.createElement(
  StyledP,
  null,
  'We will send you an email to reset your password.'
);

var _ref4 = React.createElement(
  StyledForm,
  {
    id: 'RecoverPasswordForm',
    method: 'post',
    action: '/account/recover',
    acceptCharset: 'UTF-8'
  },
  React.createElement('input', {
    type: 'hidden',
    name: 'form_type',
    defaultValue: 'recover_customer_password'
  }),
  React.createElement('input', { type: 'hidden', name: 'utf8', defaultValue: '\u2713' }),
  React.createElement(
    StyledHiddenLabel,
    { htmlFor: 'RecoverEmail' },
    'Email'
  ),
  React.createElement(StyledInput, {
    type: 'email',
    defaultValue: '',
    name: 'email',
    id: 'RecoverEmail',
    placeholder: 'Email'
  }),
  React.createElement('input', {
    type: 'submit',
    className: 'btn btn--full no-borders gradient-shimmer',
    defaultValue: 'Submit'
  })
);

var RecoverForm = function RecoverForm(_ref) {
  var toggleAccountForm = _ref.toggleAccountForm,
      isModal = _ref.isModal;
  return React.createElement(
    StyledWrapper,
    { isModal: isModal },
    _ref2,
    _ref3,
    _ref4,
    React.createElement(
      StyledFormSwitcher,
      {
        onClick: function onClick() {
          return toggleAccountForm({ formType: 'LOGIN' });
        }
      },
      'Cancel'
    )
  );
};

RecoverForm.propTypes = {
  toggleAccountForm: PropTypes.func.isRequired,
  isModal: PropTypes.bool
};

export default RecoverForm;